import logo from './logo.svg';
import './App.css';
import "./assets/css/custom.css";
import "./assets/css/style.css";
import "./assets/css/frontend.css";
import { Route, Routes, Navigate } from "react-router-dom";
import EnquiryForm from './enquiries/screens/EnquiryForm';
import DonationFormPage from './DonationSubscription/screens/DonationSubscriptionFormPage';
import DonationSubscriptionAllInvoiceView from './DonationSubscription/DonationSubscriptionAllInvoiceView';

function App() {
  return (
    
      <Routes>
        <Route path="/" element={<Navigate to="/enquiries" replace />} />
        <Route path="/enquiries" element={<EnquiryForm />} />
        <Route path="/donations" element={<DonationFormPage />} />
        <Route path="/donations/invoices" element={<DonationSubscriptionAllInvoiceView />} />
      </Routes>
  );
}

export default App;
